<template>
  <div>
    <alert
      v-if='alertVisible'
      :message='alertMessage'
      :type='alertType'>
    </alert>
    <main-layout
      controlsBg='light'
      customControls
      :hasControlsBar='false'
      :breadcrumb='getBreadcrumb'>
      <div class='container'>
        <grid-row column-align='center'>
          <grid-col col-size='4'>
            <div class='header-wrapper margin-top-xl margin-bottom-xxl'>
              <div class='title-wrapper'>
                <h1 class='header header-title'>
                  <chevron
                    @click="$router.push({name: 'Workspace'})"/>
                  {{ $t('menu.integrate') }}
                </h1>
              </div>
            </div>
          </grid-col>
        </grid-row>
        <div class='margin-top-xxl flex flex-column padding-sides'>
          <div class='center-horizontal'>
            <!-- Strava -->
            <div class='personal-area-element'>
              <font-awesome-icon
                :icon='icon.strava'
                class='personal-area-element-icon' @click='redirectStrava()'/>
              <div class='personal-area-element-title'>{{ $t('menu.strava') }}</div>
            </div>
            <div class='center-horizontal'>
              <br>
              <br v-if='!stravaChecked'>
              <font-awesome-icon
                class='fa-lg success'
                v-show='stravaChecked'
                :icon='icon.check'/>
            </div>
          </div>
          <div class='center-horizontal'>
            <!-- Fitbit -->
            <div class='personal-area-element'>
              <font-awesome-icon
                :icon='icon.fitbit'
                class='personal-area-element-icon' @click='redirectFitbit()'/>
              <div class='personal-area-element-title'>{{ $t('menu.fitbit') }}</div>
            </div>
            <div class='center-horizontal'>
              <br>
              <br v-if='!fitbitChecked'>
              <font-awesome-icon
                v-show='fitbitChecked'
                class='fa-lg success'
                :icon='icon.check'/>
            </div>
          </div>
          <div class='center-horizontal'>
            <!-- Google -->
            <div class='personal-area-element' v-on:click='redirectGoogleFit()'>
              <google-fit-logo class=''/>
              <div class='personal-area-element-title'>{{ $t('menu.googleFit') }}</div>
            </div>
            <div class='center-horizontal'>
              <br>
              <br v-if='!googleFitChecked'>
              <font-awesome-icon
                v-show=googleFitChecked
                class='fa-lg success'
                :icon='icon.check'/>
            </div>
          </div>
        </div>
        <div class='flex flex-column padding-sides'>
          <div class='center-horizontal'>
            <!-- Garmin -->
            <div class='personal-area-element'>
              <font-awesome-icon
                :icon='icon.garmin'
                class='personal-area-element-icon' @click='processGarmin()'/>
              <div class='personal-area-element-title'>{{ $t('menu.garmin') }}</div>
            </div>
            <div class='center-horizontal'>
              <br>
              <br v-if='!garminChecked'>
              <font-awesome-icon
                v-show=garminChecked
                class='fa-lg success'
                :icon='icon.check'/>
            </div>
          </div>

          <div class='center-horizontal' >
            <!-- Oura -->
            <div class='personal-area-element'>
              <font-awesome-icon
                :icon='icon.ring'
                class='personal-area-element-icon' @click='redirectOura()'/>
              <div class='personal-area-element-title'>{{ $t('menu.oura') }}</div>
            </div>
            <div class='center-horizontal'>
              <br>
              <br v-if='!ouraChecked'>
              <font-awesome-icon
                v-show=ouraChecked
                class='fa-lg success'
                :icon='icon.check'/>
            </div>
          </div>
          <div class='center-horizontal' v-has-feature="'Ring'">
            <!-- Withings -->
            <div class='personal-area-element'>
              <font-awesome-icon
                :icon='icon.scale'
                class='personal-area-element-icon' @click='redirectWithings()'/>
              <div class='personal-area-element-title'>{{ $t('menu.withings') }}</div>
            </div>
            <div class='center-horizontal'>
              <br>
              <br v-if='!withingsChecked'>
              <font-awesome-icon
                v-show=withingsChecked
                class='fa-lg success'
                :icon='icon.check'/>
            </div>
          </div>
        </div>
      </div>
      <integration-action-modal
        v-if='showModal'
        :platform='selectedPlatform'
        v-on:integrate='onIntegrate'
        v-on:remove='onRemoveIntegration'
        v-on:close='onClose'
        ref='variablePairSelectModal'
      />
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import BtnInputFile from '@/components/shared/buttons/BtnInputFile';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import Alert from '@/components/shared/alert/Alert';
import Chevron from '@/components/shared/Chevron';
import BtnPill from '@/components/shared/buttons/BtnPill';
import Radio from '@/components/shared/forms/Radio';
import AddUserModal from '@/components/group/AddUserModal';
import GoogleFitLogo from 'BRAND/components/logo/GoogleFitLogo';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {faUsers, faWatchFitness} from '@fortawesome/pro-regular-svg-icons';
import {faRunning, faRing} from '@fortawesome/free-solid-svg-icons';
import {faTriangle} from '@fortawesome/pro-solid-svg-icons';
import {faCheckCircle} from '@fortawesome/fontawesome-free-solid';
import integrationAPI from 'BRAND/api/integration/';
import IntegrationActionModal from 'BRAND/components/integration/IntegrationActionModal';
import {faWeight} from '@fortawesome/pro-solid-svg-icons/faWeight';

export default {
  name: 'Integratation',
  components: {
    GoogleFitLogo,
    AddUserModal,
    Radio,
    BtnPill,
    Chevron,
    MainLayout,
    GridRow,
    GridCol,
    BtnInputFile,
    Alert,
    FontAwesomeIcon,
    IntegrationActionModal
  },
  data () {
    return {
      code: null,
      state: null,
      scope: null,
      fitbitChecked: false,
      stravaChecked: false,
      googleFitChecked: false,
      ouraChecked: false,
      withingsChecked: false,
      garminChecked: false,
      showModal: false,
      selectedPlatform: null,
      platformsData: [],
      /* UI controls */
      alertVisible: false,
      alertMessage: '',
      alertType: '', // error, warning, success
      icon: {
        users: faUsers,
        strava: faRunning,
        fitbit: faWatchFitness,
        ring: faRing,
        garmin: faTriangle,
        check: faCheckCircle,
        scale: faWeight
      }
    };
  },
  mounted () {
    integrationAPI.getIntegratedPlatforms(this).then((data) => {
      if (data) {
        this.platformsData = data.items;
        const stravaData = this.platformsData.find(
          (platform) => platform.platform === 'Strava'
        );
        this.stravaChecked = stravaData.allowed;
        const fitbitData = this.platformsData.find(
          (platform) => platform.platform === 'Fitbit'
        );
        this.fitbitChecked = fitbitData.allowed;
        const googleFitData = this.platformsData.find(
          (platform) => platform.platform === 'GoogleFit'
        );
        this.googleFitChecked = googleFitData.allowed;
        const ouraData = this.platformsData.find(
          (platform) => platform.platform === 'Oura'
        );
        this.ouraChecked = ouraData.allowed;
        const withingsData = this.platformsData.find(
          (platform) => platform.platform === 'Withings'
        );
        this.withingsChecked = withingsData.allowed;
        const garminData = this.platformsData.find(
          (platform) => platform.platform === 'Garmin'
        );
        this.garminChecked = garminData.allowed;
      }
    });
    this.code = this.$route.query.code;
    this.state = this.$route.query.state;
    this.scope = this.$route.query.scope;
    const oauthToken = this.$route.query.oauthToken;
    const oauthVerifier = this.$route.query.oauthVerifier;
    if (oauthToken != null) {
      if (oauthVerifier === null || oauthVerifier === 'null') {
        showAlert(this, this.$t('health.integration.error'), 'error');
        return;
      } else {
        this.code = oauthToken;
      }
    }
    const body = {
      code: this.code,
      state: this.state,
      verifier: oauthVerifier
    };
    if (this.code != null && this.state != null) {
      if (
        this.state === '3' &&
        (this.scope === null || this.scope.split('').length < 2)
      ) {
        showAlert(this, this.$t('health.integration.notEnoughScopes'), 'error');
      } else {
        if (oauthVerifier == null && this.state === '4') {
          showAlert(this, this.$t('health.integration.error'), 'error');
        }
        integrationAPI
          .dataIntegrationPost(this, body)
          .then(() => {
            showAlert(this, this.$t('health.integration.success'), 'success');
            if (this.state === '1') {
              this.stravaChecked = true;
            }
            if (this.state === '2') {
              this.fitbitChecked = true;
            }
            if (this.state === '3') {
              this.googleFitChecked = true;
            }
            if (this.state === '4') {
              this.garminChecked = true;
            }
            if (this.state === '5') {
              this.ouraChecked = true;
            }
            if (this.state === '7') {
              this.withingsChecked = true;
            }
          })
          .catch(() => {
            if (this.state === '3') {
              showAlert(
                this,
                this.$t('health.integration.noRefreshToken'),
                'error'
              );
            }
          });
      }
    }
  },
  computed: {
    getBreadcrumb () {
      return [
        {name: this.$t('menu.workspace'), link: '/workspace'},
        {name: this.$t('menu.integrate'), disabled: true}
      ];
    }
  },
  methods: {
    redirectStrava () {
      if (this.stravaChecked) {
        this.selectedPlatform = 'Strava';
        this.showModal = true;
      } else {
        const stravaData = this.platformsData.find(
          (platform) => platform.platform === 'Strava'
        );
        window.location.replace(
          'https://www.strava.com/oauth/authorize?client_id=' +
          stravaData.clientId +
          '&response_type=code&scope=activity:read_all,activity:read&state=1&redirect_uri=' +
          window.location.href.split('?')[0].replace('#', '%23')
        );
      }
    },
    redirectFitbit () {
      if (this.fitbitChecked) {
        this.selectedPlatform = 'Fitbit';
        this.showModal = true;
      } else {
        const fitbitData = this.platformsData.find(
          (platform) => platform.platform === 'Fitbit'
        );
        const redirectUri = encodeURI(window.location.href.split('#')[0]);
        window.location.replace(
          'https://www.fitbit.com/oauth2/authorize?response_type=code&client_id=' +
          fitbitData.clientId +
          '&redirect_uri=' +
          redirectUri +
          '&scope=activity%20heartrate%20location%20nutrition%20profile%20settings%20sleep%20social%20weight&expires_in=604800'
        );
      }
    },

    redirectOura () {
      if (this.ouraChecked) {
        this.selectedPlatform = 'Oura';
        this.showModal = true;
      } else {
        const ouraData = this.platformsData.find(
          (platform) => platform.platform === 'Oura'
        );
        const redirectUri = encodeURI(window.location.href.split('#')[0]);
        window.location.replace(
          'https://cloud.ouraring.com/oauth/authorize?response_type=code&client_id=' +
          ouraData.clientId +
          '&redirect_uri=' +
          redirectUri +
          '&scope=email personal daily heartrate workout tag session spo2&state=5'
        );
      }
    },
    redirectWithings () {
      if (this.withingsChecked) {
        this.selectedPlatform = 'Withings';
        this.showModal = true;
      } else {
        const withingsData = this.platformsData.find(
          (platform) => platform.platform === 'Withings'
        );
        const redirectUri = encodeURI(window.location.href.split('#')[0]);
        window.location.replace(
          'https://account.withings.com/oauth2_user/authorize2?response_type=code&client_id=' +
          withingsData.clientId +
          '&redirect_uri=' +
          redirectUri +
          '&scope=user.activity,user.metrics&state=7'
        );
      }
    },
    redirectGoogleFit: function () {
      if (this.googleFitChecked) {
        this.selectedPlatform = 'GoogleFit';
        this.showModal = true;
      } else {
        const googletData = this.platformsData.find(
          (platform) => platform.platform === 'GoogleFit'
        );
        const redirectUri = encodeURI(window.location.href.split('#')[0]);
        window.location.replace(
          'https://accounts.google.com/o/oauth2/v2/auth?client_id=' +
          googletData.clientId +
          '&redirect_uri=' +
          redirectUri +
          '&response_type=code&scope=https://www.googleapis.com/auth/fitness.activity.read https://www.googleapis.com/auth/userinfo.profile&access_type=offline&state=3'
        );
      }
    },
    processGarmin () {
      if (this.garminChecked) {
        this.selectedPlatform = 'Garmin';
        this.showModal = true;
      } else {
        integrationAPI.getGarminTokens(this).then((data) => {
          const redirectUri = encodeURI(window.location.href.split('#')[0]);
          window.location.replace(
            'https://connect.garmin.com/oauthConfirm?oauth_token=' +
            data +
            '&oauth_callback=' +
            redirectUri
          );
        });
      }
    },
    onClose () {
      this.showModal = false;
      this.selectedPlatform = null;
    },
    onIntegrate () {
      const platform = this.selectedPlatform;
      this.onClose();
      if (platform === 'Strava') {
        this.stravaChecked = false;
        this.redirectStrava();
      } else if (platform === 'Fitbit') {
        this.fitbitChecked = false;
        this.redirectFitbit();
      } else if (platform === 'GoogleFit') {
        this.googleFitChecked = false;
        this.redirectGoogleFit();
      } else if (platform === 'Garmin') {
        this.garminChecked = false;
        this.processGarmin();
      } else if (platform === 'Oura') {
        this.ouraChecked = false;
        this.redirectOura();
      } else if (platform === 'Withings') {
        this.withingsChecked = false;
        this.redirectWithings();
      }
    },
    onRemoveIntegration () {
      let state;
      if (this.selectedPlatform === 'Strava') {
        state = 1;
      } else if (this.selectedPlatform === 'Fitbit') {
        state = 2;
      } else if (this.selectedPlatform === 'GoogleFit') {
        state = 3;
      } else if (this.selectedPlatform === 'Garmin') {
        state = 4;
      } else if (this.selectedPlatform === 'Oura') {
        state = 5;
      } else if (this.selectedPlatform === 'Withings') {
        state = 7;
      }
      this.onClose();
      if (state === null) {
        return;
      }
      integrationAPI
        .removeIntegration(this, state)
        .then(() => {
          showAlert(
            this,
            this.$t('health.integration.integrationRemoved'),
            'success'
          );
          if (state === 1) {
            this.stravaChecked = false;
          } else if (state === 2) {
            this.fitbitChecked = false;
          } else if (state === 3) {
            this.googleFitChecked = false;
          } else if (state === 4) {
            this.garminChecked = false;
          } else if (state === 5) {
            this.ouraChecked = false;
          } else if (state === 7) {
            this.withingsChecked = false;
          }
          this.onClose();
        })
        .catch(() => {
          showAlert(
            this,
            this.$t('health.integration.integrationRemovedError'),
            'error'
          );
          this.onClose();
        });
    }
  }
};

const showAlert = (context, message, type) => {
  context.alertVisible = true;
  context.alertMessage = message;
  context.alertType = type;
  context.showAlert = true;
  setTimeout(() => {
    context.alertVisible = false;
  }, 3000);
};
</script>

<style lang='scss'>
@import 'src/stylesheets/variables';

.buttons {
  text-align: center;
}

.personal-area-element {
  align-items: center;
  display: inline-block;
  text-align: center;
  background-color: $black-light9;
  border: solid 0.2rem $black-light9;
  border-radius: $radius;
  height: 15rem;
  width: 15rem;
  color: $secondary;
  margin: 1rem;
  padding-top: 2.7rem;
}

.personal-area-element:hover {
  border: solid 0.2rem $black-light5;
}

.personal-area-element-icon {
  font-size: 7rem;
}

.personal-area-element-title {
  font-size: 1.3rem;
  font-weight: bold;
}

.disabled,
.disabled:hover {
  color: $secondary-trans7;
  border: solid 0.2rem $black-light9;
}

.center-horizontal {
  display: table;
  margin: 0 auto;
}

.padding-sides {
  padding-right: 30%;
  padding-left: 25%;
}

.flex-column {
  @media (max-width: $screen-xl-max) {
    flex-direction: column;
  }
  @media (min-width: $screen-xl-max) {
    flex-direction: row;
  }
}
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/Integration.vue